import type { ReactNode } from 'react';
import { Building2, Lock } from 'lucide-react';
import { AppLayout } from '@/components/layout/app-layout';
import { PageHeader, PestanasDeNavegacion } from '@/components/patterns';
import { esSeccionDelPlanCompletoEnLaDemo } from '@/features/mini-prixia/empresa-demo';
import { useNombreDeLaEmpresa } from '../hooks/use-nombre-de-la-empresa';
import { SECCIONES, rutaDeSeccion } from '../lib/secciones';
import type { SeccionDeMiEmpresa } from '../services/mi-empresa-service';

/**
 * El marco de Mi empresa (maqueta de Melanie, 25-oct): el encabezado de cada
 * sección y las siete pestañas. En Resumen el título es «Mi empresa»; en las
 * demás, la píldora «Mi empresa · {empresa}» y el nombre de la sección, con su
 * acción principal a la derecha.
 */
export function MarcoDeMiEmpresa({
  seccion,
  acciones,
  dataTour,
  children,
}: {
  seccion: SeccionDeMiEmpresa;
  acciones?: ReactNode;
  /** El paso del tour guiado que apunta al encabezado (`users-header`…). */
  dataTour?: string;
  children: ReactNode;
}) {
  const empresa = useNombreDeLaEmpresa();
  const def = SECCIONES.find((s) => s.id === seccion)!;
  return (
    <AppLayout>
      <div className="mx-auto flex max-w-[1440px] flex-col gap-6 px-4 py-8 md:px-8">
        <div data-tour={dataTour}>
          <PageHeader
            etiqueta={
              seccion === 'resumen' ? undefined : empresa ? `Mi empresa · ${empresa}` : 'Mi empresa'
            }
            icono={Building2}
            tonoEtiqueta="neutro"
            titulo={def.titulo}
            subtitulo={def.subtitulo}
            acciones={acciones}
          />
        </div>
        <PestanasDeNavegacion
          etiqueta="Secciones de Mi empresa"
          pestanas={SECCIONES.map((s) => ({
            texto: s.texto,
            href: rutaDeSeccion(s.id),
            activa: s.id === seccion,
            // En la demo, lo que no incluye la prueba lleva candado (abre el cuadro del plan completo).
            icono: esSeccionDelPlanCompletoEnLaDemo(s.id) ? Lock : undefined,
          }))}
        />
        {children}
      </div>
    </AppLayout>
  );
}
